import React, { useEffect, useState } from "react";
import { Drawer, Form, Input } from "antd";
import { registerEmployee } from "../../../lib/registerEmployee";
import { getEmployees } from "../../../lib/getEmployees";
import { toast, ToastContainer } from "react-toastify";

const RegisterEmployee = ({ setEmployeeList, openDrawer, setOpenDrawer }) => {
  const notifyBottomRight = () => {
    toast.success("✔️ Empleado registado exitosamente.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  };

  const failNotifyBottomRight = () => {
    toast.error("✔️ El DNI ingresado ya está registrado.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  };

  const [form] = Form.useForm();

  return (
    <>
      <ToastContainer />
      <Drawer
        style={{
          backgroundColor: "#362465",
          borderTopLeftRadius: "15px",
          borderBottomLeftRadius: "15px",
        }}
        destroyOnClose
        width={500}
        closable={false}
        title={<label style={{ color: "white" }}>Nuevo empleado</label>}
        placement={"right"}
        onClose={() => {
          setOpenDrawer(false);
          form.resetFields();
        }}
        open={openDrawer}
        key={"right"}
      >
        <Form
          size="small"
          layout="vertical"
          name="employee"
          form={form}
          onFinish={(v) => {
            const { companyProfile } = JSON.parse(
              window.localStorage.getItem("userDetails")
            );
            const employee = { ...v.employee, idCompany: companyProfile._id };
            registerEmployee(employee).then((res) => {
              if (res.status === 200) {
                getEmployees(companyProfile._id).then((res) => {
                  setEmployeeList(res.data);
                });
                form.resetFields();
                setOpenDrawer(false);
                notifyBottomRight();
              } else {
                failNotifyBottomRight();
              }
            });
          }}
        >
          <Form.Item
            name={["employee", "cuil"]}
            label={<label style={{ color: "white" }}>CUIL</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["employee", "name"]}
            label={<label style={{ color: "white" }}>Apellido y Nombre</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["employee", "dni"]}
            label={<label style={{ color: "white" }}>DNI</label>}
            rules={[
              {
                required: true,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>
          {/* 
          <Form.Item
            name={["employee", "charge"]}
            label={<label style={{ color: "white" }}>Cargo</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item> */}

          <Form.Item
            name={["employee", "email"]}
            label={<label style={{ color: "white" }}>Email</label>}
            rules={[
              {
                required: true,
                type: "email",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["employee", "phoneNumber"]}
            label={<label style={{ color: "white" }}>Teléfono</label>}
            rules={[
              {
                required: true,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>

          {/* <Form.Item
            name={["employee", "place"]}
            label={<label style={{ color: "white" }}>Lugar de trabajo</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item> */}
          <Form.Item
            name={["employee", "salary"]}
            label={<label style={{ color: "white" }}>Salario bruto</label>}
            rules={[
              {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              marginTop: "25%",
            }}
          >
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                htmlType="submit"
                className="btn btn-primary"
              >
                Guardar
              </button>
            </Form.Item>
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenDrawer(false);
                }}
              >
                Cancelar
              </button>
            </Form.Item>
          </div>
        </Form>
      </Drawer>
    </>
  );
};

export default RegisterEmployee;
